import React from 'react';
import client from '../tina/__generated__/client';
import { Exact, PrivacyQuery } from '../tina/__generated__/types';
import { useTina } from 'tinacms/dist/react';
import { Heading } from 'shared/Typography';
import { Section } from 'react-headings';
import { Flex } from 'components/atoms/Flex';

import { MarkdownWithTypo } from 'components/organisms/MarkdownWithTypo/MarkdownWithTypo';
import { NextSeo, NextSeoProps } from 'next-seo';
export default function ServicesAndPrices(props: {
  data: PrivacyQuery;
  query: string;
  variables: Exact<{ relativePath: string }>;
}) {
  const { data } = useTina({
    query: props.query,
    variables: props.variables,
    data: props.data,
  });

  return (
    <>
      <NextSeo {...(data.privacy.seo as NextSeoProps)} />
      <Flex
        css={{
          flexDirection: 'column',
          paddingInline: '$spacingMainMobile',
          paddingBlock: '$spacing-5x',
          '@tabletAndUp': {
            paddingBlock: 0,
          },
        }}
      >
        <Flex
          css={{
            flexDirection: 'column',
            maxWidth: '$textContent',
            margin: 'auto',
            gap: '$spacing-3x',
            alignContent: 'stretch',
            justifyContent: 'center',
            width: '100%',
            '@tabletAndUp': {
              gap: '$spacing-3x',
              paddingBlock: '$spacing-8x',
            },
          }}
        >
          <Section
            component={
              <Heading
                variant={{ '@initial': 'h2', '@tabletAndUp': 'h2TabletAndUp' }}
              >
                {data.privacy?.headline}
              </Heading>
            }
          >
            <Flex
              css={{
                width: '100%',
                maxWidth: '$textContent',
                margin: 'auto',
              }}
            >
              <MarkdownWithTypo content={data.privacy?.content} />
            </Flex>
          </Section>
        </Flex>
      </Flex>
    </>
  );
}

export const getStaticProps = async () => {
  const pageResponse = await client.queries.privacy({
    relativePath: 'datenschutz.mdx',
  });

  return {
    props: {
      data: pageResponse.data,
      query: pageResponse.query,
      variables: pageResponse.variables,
    },
  };
};
